import { getAllTenant } from '../../../../Utils/Auth/ValidatePermissions';
import { LOOKUP_TYPES } from '../../../../constants/applicationConstants';
import {
  retrieveAndDecrypt,
  encryptAndStore,
  getLookupFromLocalStorage,
} from '../../../../Utils/Storage/localStorageUtil';
import { getLookupByType } from '../../Login/Services/LoginService';

/**
 * Retrieves a list of Tenants.
 * @returns {Promise<object[]>} A list of shifts, where each Tenants is represented as an object.
 */
export const Tenants = () => {
  const data = getAllTenant();
  return data
    ? [
        { label: '(All)', value: '' },
        ...data.map((item) => ({
          label: item.TenantName,
          value: item.TenantName,
        })),
      ]
    : [];
};

export const getLookUpByType = async ({ type }) => {
  // Try to get data from localStorage first
  let data = getLookupFromLocalStorage({ type });

  // If no data in localStorage, fetch from API
  if (!data) {
    try {
      let response = await getLookupByType({
        type,
      });

      data = response?.Payload;
      encryptAndStore(LOOKUP_TYPES?.groupTypes, response?.Payload);
    } catch (error) {
      console.error('Error lookup from API:', error);
      return [];
    }
  }

  return data;
};

/**
 * Retrieves a list of Test Type.
 */
export const testTypes = () => {
  const data = retrieveAndDecrypt(LOOKUP_TYPES?.testTypes);
  return data
    ? [
        { label: '(All)', value: '' },
        ...data.map((item) => ({
          label: item.DisplayName,
          value: item.DisplayName,
        })),
      ]
    : [];
};
/**
 * Retrieves a list of gorup.
 */

export const groupTypes = () => {
  // Try to get data from localStorage first
  const data = retrieveAndDecrypt(LOOKUP_TYPES?.groupTypes);
  return data
    ? [
        { label: '(All)', value: '' },
        ...data.map((item) => ({
          label: item.DisplayName,
          value: item.DisplayName,
        })),
      ]
    : [];
};
/**
 * Retrieves a list of Field Info Type.
 */
export const fieldInfoTypes = () => {
  const data = retrieveAndDecrypt(LOOKUP_TYPES?.fieldInfoTypes);
  return data
    ? [
        { label: '(All)', value: '' },
        ...data.map((item) => ({
          label: item.DisplayName,
          value: item.DisplayName,
        })),
      ]
    : [];
};
/**
 * Retrieves a list of MTF Protocol Type.
 */
export const mtfProtocol = () => {
  const data = retrieveAndDecrypt(LOOKUP_TYPES?.mtfProtocol);
  return data
    ? [
        { label: '(All)', value: '' },
        ...data.map((item) => ({
          label: item.DisplayName,
          value: item.DisplayName,
        })),
      ]
    : [];
};
/**
 * Retrieves a Boolean Values.
 */
export const BooleanValues = () => {
  const booleanValues = [
    { label: '(All)', value: '' },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
  ];
  return booleanValues.map((item, i) => ({
    label: item.label,
    value: item.value,
  }));
};
/**
 * Retrieves a Boolean Flag True False Values.
 */
export const BooleanFlagValues = () => {
  const booleanValues = [
    { label: '(All)', value: '' },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ];
  return booleanValues.map((item, i) => ({
    label: item.label,
    value: item.value,
  }));
};
